/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React  from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components//shared/Buttons/BackButton'; 
import { MdPermDeviceInformation, MdSettingsApplications } from 'react-icons/md';
import ContentCard from '../../../../../components//ui-elements/cards/ContentCard'; 
import { BsFillPeopleFill, BsServer } from 'react-icons/bs';

const ManageOrganizationsApplicationsPage = ( ) => { 



    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-details" title="Applications" subTitle="Manage  Applications" icon={<MdSettingsApplications />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-users" title="Users" subTitle="Manage  Users" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-devices" title="Devices" subTitle="Manage  Devices" icon={<MdPermDeviceInformation />}></ContentCard>
                    </Grid> 
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications-identity-providers" title="Identity Providers" subTitle="Manage  Identity Providers" icon={<BsServer />}></ContentCard>
                    </Grid> 
                </Grid>
            </Box>

        </>
    )

}
 
 
export default ManageOrganizationsApplicationsPage; 
